import React from 'react';
import { PLAN_TIER } from '../../utils/pluginPlan';

const PLAN_META = {
	[PLAN_TIER.FREE]: {
		label: 'Free',
		shortLabel: 'Free',
	},
	[PLAN_TIER.PRO]: {
		label: 'Pro',
		shortLabel: 'Pro',
	},
};

function PlanBadge({ tier, className = '' }) {
	if (!tier || !PLAN_META[tier]) {
		return null;
	}

	const { label, shortLabel } = PLAN_META[tier];

	return (
		<span
			className={`plan-badge plan-badge--${tier} plan-tooltip ${className}`.trim()}
			aria-label={label}
		>
			{shortLabel}
			<span className="tooltip-text">{label} plan</span>
		</span>
	);
}

export default PlanBadge;
